<!-- Generated template for the AppListingComponent component -->
<div class="app_listing clickable" (click)="doOpenApp(app.token)">
    <div class="app_name">{{appTitle()}}</div>
    <div class="color_chiclets">
      <div *ngFor="let fr of app.formulas" class="color_chiclet" [attr.style]="tileBgStyle(fr)">&nbsp;</div>
    </div>
</div>
